<template>
  <main id="main" class="landing">
    <Header/>
    <router-view/>
    <Footer/>
    <RegisterModal/>
    <LoginModal/>
    <WaitingDialog/>
    <VerifyEmailSuccess/>
    <ForgotPassword/>
    <Remove2FASuccess/>
  </main>
</template>

<script>
import Header from '@/views/layout/components/Header'
import Footer from '@/views/layout/components/Footer'
import RegisterModal from '@/views/modal/RegisterModal'
import ForgotPassword from '@/views/modal/ForgotPassword'
import LoginModal from '@/views/modal/LoginModal'
import VerifyEmailSuccess from '@/views/modal/VerifyEmailSuccess'
import WaitingDialog from '@/views/modal/WaitingDialog'
import Remove2FASuccess from '@/views/modal/Remove2FASuccess'
export default {
  components: {
    Header,
    Footer,
    RegisterModal,
    LoginModal,
    WaitingDialog,
    VerifyEmailSuccess,
    ForgotPassword,
    Remove2FASuccess
  },
  created () {
    this.$store.dispatch('getUser')
  }
}
</script>
